export const enum ViewOptions {
	default = "default",
	polling = "polling",
	qr = "qr-code",
	personalNumber = "personal-number",
}
export const REGISTRATION_BANKID_AUTH_TRANSLATIONS = {
	images: ["general.bankid", "general.bankid.error"],
	translations: [
		"general.ok",
		"general.close",
		"general.cancel",
		"general.contact",
		"sga-auth-transaction.bankid.start",
		"sga-auth-transaction.retry-bankid",
		"sga-auth-transaction.bankid-on-another-device",
		"sga-auth-transaction.retry-bankid-on-another-device",
		"sga-auth-transaction.polling",
		"sga-auth-transaction.polling-timeout",
		"sga-auth-transaction.bankid-login-title",
		"sga-auth-transaction.bankid-registration-title",
		"sga-auth-transaction.bankid-welcome-title",
		"sga-auth-transaction.bankid-welcome-subtitle",
		"sga-auth-transaction.bankid-polling-subtitle",
		"sga-auth-transaction.scan-qr-code-subtitle",
		"sga-auth-transaction.bankid-personal-number-title",
		"sga-auth-transaction.bankid-personal-number-subtitle",
		"sga-auth-transaction.personal-number-continue",
		"sga-auth-transaction.registration.not-swedish-resident-message",
		"sga-auth-transaction.registration.not-swedish-resident-action",
		"sga-auth-transaction.registration.bankid-error-message",
		"sga-auth-transaction.registration.bankid-error-action",
		"sga-auth-transaction.registration.personal-number-try-again-message",
		"sga-auth-transaction.registration.personal-number-try-again-action",
		"sga-auth-transaction.polling-cancel-message",
		"sga-auth-transaction.polling-cancel-action",
		"sga-auth-transaction.qr-code-different-method-message",
		"sga-auth-transaction.qr-code-different-method-action",
		"sga-login-transaction.m_cancel_last_verification_success",
		"sga-login-transaction.error.text",
		"sga-login-transaction.e_personalverification_nodata",
		"sga-login-transaction.initialize.fail",
		"sga-login-transaction.error.personal-number-not-found",
		"sga-login-transaction.bankid-not-responding-error",
	],
	qrCodeComponentTranslations: [
		"sga.qr-generate",
		"sga-auth-transaction.qr-instructions-accordion-label",
		"sga-auth-transaction.qr-instructions-accordion-open-bankid",
		"sga-auth-transaction.qr-instructions-accordion-open-scanqr",
		"sga-auth-transaction.qr-instructions-accordion-open-aim-camera",
		"sga-auth-transaction.qr-instructions-accordion-open-follow-instructions",
		"sga-auth-transaction.qr-instructions-accordion-help-try-again",
		"sga-auth-transaction.qr-instructions-accordion-help-qr-fits",
		"sga-auth-transaction.qr-screen-reader-accordion-label",
		"sga-auth-transaction.qr-screen-reader-accordion-help-common-issue",
		"sga-auth-transaction.qr-screen-reader-accordion-screen-switched",
		"sga-auth-transaction.qr-screen-reader-accordion-zoom-out",
		"sga-auth-transaction.qr-screen-reader-accordion-window-maximized",
		"sga-auth-transaction.qr-screen-reader-accordion-click-qr",
		"sga-auth-transaction.qr-screen-reader-accordion-use-short-commands",
		"sga-auth-transaction.qr-screen-reader-accordion-windows-short-command",
		"sga-auth-transaction.qr-screen-reader-accordion-mac-short-command",
		"sga-auth-transaction.qr-screen-reader-accordion-hold-phone",
		"sga-auth-transaction.qr-screen-reader-accordion-cancelled-try-again",
		"sga-auth-transaction.qr-screen-reader-accordion-help-qr-fits",
		"sga-auth-transaction.extend-seconds-left",
		"sga-auth-transaction.minutes-left",
		"sga-auth-transaction.-qr-accessibility-hint",
	],
};
